import { createContext, useContext, type ReactNode } from "react";
import type { ClientInfo } from "./ClientCustomization";
import sentinelLogo from "@/assets/sentinelforge-logo.webp";

const BrandingContext = createContext<Partial<ClientInfo>>({});
export const ProposalBrandingProvider = ({ info, children }: { info: Partial<ClientInfo>; children: ReactNode }) => (
  <BrandingContext.Provider value={info}>{children}</BrandingContext.Provider>
);

export function ProposalLetterhead({ title }: { title: string }) {
  const info = useContext(BrandingContext);
  const position = info.brandingTextPosition ?? "footer";
  const logo = info.logoUrl || (!info.removeBranding ? sentinelLogo : undefined);
  return (
    <header className="proposal-letterhead" data-pdf-block>
      <div className="flex items-center gap-4 min-w-0">
        {logo && <img src={logo} alt={info.companyName ? `${info.companyName} logo` : "Sentinel Forge Systems logo"} className="h-16 w-24 shrink-0 object-contain" />}
        <div className="min-w-0 space-y-1">
          <p className="text-lg font-bold text-foreground break-words">{info.companyName || (!info.removeBranding ? "Sentinel Forge Systems" : title)}</p>
          <h2 className="text-xs font-semibold uppercase text-primary break-words">{title}</h2>
          {(info.contactEmail || info.contactPhone) && <p className="text-xs text-secondary-foreground break-words">{[info.contactEmail, info.contactPhone].filter(Boolean).join(" · ")}</p>}
        </div>
      </div>
      {info.footerText && position !== "footer" && <p className="mt-4 border-t border-border pt-3 text-sm text-secondary-foreground whitespace-pre-wrap break-words">{info.footerText}</p>}
    </header>
  );
}

export function ProposalDocumentFooter() {
  const info = useContext(BrandingContext);
  const position = info.brandingTextPosition ?? "footer";
  return (
    <footer className="proposal-document-footer" data-pdf-block>
      {info.footerText && position !== "header" && <p className="whitespace-pre-wrap break-words">{info.footerText}</p>}
      {!info.removeBranding && <p className="mt-2">Prepared with Sentinel Forge Systems</p>}
    </footer>
  );
}